import {IWayPointCreationWithCorrectionsSingleVoyage} from "@containers/singleVoyage/types/point";

export const deletePointsCorrectionsOnReorderMutateSingleVoyage = ({
                                                                             points,
                                                                             newPointIndex,
                                                                             oldPointIndex
                                                                         }: {
    points: IWayPointCreationWithCorrectionsSingleVoyage[],
    oldPointIndex: number,
    newPointIndex: number,
}):IWayPointCreationWithCorrectionsSingleVoyage[]=>{
    const indexesToClear = [
        oldPointIndex - 1,
        oldPointIndex,
        newPointIndex - 1,
        newPointIndex
    ]

    return points.map((point, index) => ({
        ...point,
        correctionWaypoints: indexesToClear.includes(index) ? [] : point.correctionWaypoints
    }));
}